import { Box, Button, Stack, Typography } from '@mui/joy';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { LayoutContext } from '../context';
import { getHomePathForRole } from '../roles';

export default function NotFoundPage() {
    const navigate = useNavigate();
    const { effectiveRole } = useContext(LayoutContext);
    const homePath = getHomePathForRole(effectiveRole);

    return (
        <Box sx={{ height: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
            <Stack spacing={2} sx={{ maxWidth: 400, textAlign: 'center' }}>
                <Typography level="h3">Страница не найдена</Typography>
                <Typography level="body-md" color="neutral">
                    Возможно, ссылка устарела или путь введён неправильно.
                </Typography>
                <Button onClick={() => navigate(homePath, { replace: true })}>
                    На главную
                </Button>
            </Stack>
        </Box>
    );
}